import { map, pathOr } from 'ramda';

import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

export const mapTeethToISONumbers = (teeth: Tooth[]) =>
  map<Tooth, number>(pathOr(0, ['Numeration', 'ISO']))(teeth);
